import { captureMessage } from "@sentry/react";
import { io, type Socket } from "socket.io-client";

export type ApplicationSocketNamespace = "application" | "applicationComment";

export const getApplicationSocketUrl = (
  namespace: ApplicationSocketNamespace,
  apiUrl = import.meta.env.VITE_API_URL,
): string => (apiUrl?.startsWith("http") ? `${apiUrl}/${namespace}` : `/${namespace}`);

export const createApplicationSocket = (namespace: ApplicationSocketNamespace): Socket => {
  const socket = io(getApplicationSocketUrl(namespace), {
    transports: ["websocket", "polling"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
  });

  let lastReportedError = "";
  socket.on("connect", () => {
    lastReportedError = "";
  });
  socket.on("connect_error", (error) => {
    const message = error instanceof Error ? error.message : String(error);
    if (message !== lastReportedError) {
      captureMessage(`Socket.IO ${namespace} connection failed: ${message}`);
      lastReportedError = message;
    }
  });

  return socket;
};
